module.exports = __webpack_public_path__ + "img/政府企事业单位信息化建设.92f3018a.png";